export default __webpack_public_path__ + "static/media/rolex-watch.358e6953.png";